export type translationMapType = {
    [key: string]: string;
};
export const translationMap: translationMapType = {
    name: '姓名',
    username: '用戶暱稱',
    email: '電郵'
};